module.exports = __webpack_public_path__ + "static/media/elk_dnd_3.c70eca97.jpg";